import { render, staticRenderFns } from "./RegistrarContatos.vue?vue&type=template&id=6bd39f06&"
import script from "./RegistrarContatos.vue?vue&type=script&lang=js&"
export * from "./RegistrarContatos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports